import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    JUST_NOW: "только что",
    MORE_THAN_HALF_A_YEAR_AGO: "более полугода назад",
    buildMonthsAgoText: (count) => `${count} ${buildCorrectGrammarText(count, ["месяц", "месяца", "месяца"])} назад`,
    buildWeeksAgoText: (count) => `${count} ${buildCorrectGrammarText(count, ["неделю", "недели", "недель"])} назад`,
    buildDaysAgoText: (count) => `${count} ${buildCorrectGrammarText(count, ["день", "дня", "дней"])} назад`,
    buildHoursAgoText: (count) => `${count} ${buildCorrectGrammarText(count, ["час", "часа", "часов"])} назад`,
    buildMinutesAgoText: (count) => `${count} ${buildCorrectGrammarText(count, ["минуту", "минуты", "минут"])} назад`,
    IN_TIME_PREPOSITION: "в"
};
